import { render, staticRenderFns } from "./AllocationTab.vue?vue&type=template&id=407ae65d&scoped=true"
import script from "./AllocationTab.vue?vue&type=script&lang=ts"
export * from "./AllocationTab.vue?vue&type=script&lang=ts"
import style0 from "./AllocationTab.vue?vue&type=style&index=0&id=407ae65d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ae65d",
  null
  
)

export default component.exports